module.exports = __webpack_public_path__ + "static/media/waiter.443aee60.png";